module.exports = __webpack_public_path__ + "img/code_ref.5882b801.svg";